import { UserParams } from "../../../context/user-params-context"
import { ReportParameterDatePart } from "../../../logic/api"
import { LabelFormatOptions, ILabelOptions } from "./chart-options"


export function formatMinutesToHHMM(minutes?: string) {
  if (!minutes || Number(minutes) === 0) {
    return "00:00"
  }

  const rounded = Math.round(Number(minutes))
  const mins = rounded % 60
  const hours = (rounded - mins) / 60

  return `${_pad(hours)}:${_pad(mins)}`
}

function _pad(n: number) {
  return `${n < 10 ? "0" : ""}${n}`
}

export function formatLabel(
  userParams: UserParams,
  label?: ILabelOptions
): string {
  if (label?.value === '@u_interval') {
    if (!userParams["@u_interval"] && userParams["@u_interval"] !== 0) {
      return 'Interval'
    }

    return ReportParameterDatePart[userParams["@u_interval"]]
  }

  if (label?.format === LabelFormatOptions["HH:MM"]) {
    return formatMinutesToHHMM(label.value)
  }

  return label?.value || ""
}
